import { LogLevel } from '../types/LogLevel';
import { LOG_LEVELS } from './LOG_LEVELS';

/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Log level hierarchy ordered from lowest to highest priority</blockquote>
 * 
 * @example
 * ```typescript
 * const levels: LogLevel[] = LOG_LEVEL_HIERARCHY;
 * const configuredLevelIndex = levels.indexOf(LOG_LEVELS.INFO);
 * const entryLevelIndex = levels.indexOf(entry.level);
 * return entryLevelIndex >= configuredLevelIndex;
 * ```
 * 
 * @remarks
 * This array defines the order of log levels from lowest to highest priority.
 * Used for determining if a log entry should be processed based on the configured level.
 * 
 * Common values:
 * - LOG_LEVELS.NONE: No logging
 * - LOG_LEVELS.DEBUG: Debug level logging
 * - LOG_LEVELS.INFO: Information level logging  
 * - LOG_LEVELS.WARN: Warning level logging
 * - LOG_LEVELS.ERROR: Error level logging
 */
export const /**
 * @internal
 */
LOG_LEVEL_HIERARCHY: LogLevel[] = [
  LOG_LEVELS.NONE,
  LOG_LEVELS.DEBUG,
  LOG_LEVELS.INFO,
  LOG_LEVELS.WARN,
  LOG_LEVELS.ERROR
] as const;
